module.exports = __webpack_public_path__ + "fc2a0bdfa9d3d2cb38509b363b7c6122.md";